import { Effect, Option, Schema } from 'effect';

export const readStored = <S extends Schema.Codec<unknown, unknown>>(
  key: string,
  schema: S,
  fallback: S['Type'],
): S['Type'] =>
  Effect.try(() => globalThis.localStorage.getItem(key)).pipe(
    Effect.map(Option.fromNullishOr),
    Effect.map(Option.flatMap(Schema.decodeUnknownOption(Schema.fromJsonString(schema)))),
    Effect.map(Option.getOrElse(() => fallback)),
    Effect.orElseSucceed(() => fallback),
    Effect.runSync,
  );

export const writeStored = <S extends Schema.Codec<unknown, unknown>>(
  key: string,
  schema: S,
  value: S['Type'],
) =>
  Schema.encodeEffect(Schema.fromJsonString(schema))(value).pipe(
    Effect.flatMap((json) => Effect.try(() => globalThis.localStorage.setItem(key, json))),
    Effect.ignore,
    Effect.runSync,
  );
